import React, {PropsWithChildren, ReactElement} from 'react';
import {AnimationString} from '../../../../incase-domain/common/animationString';

interface AnimatedProps {
    animationIn?: AnimationString;
    animationInDelay?: number;
    animationInDuration?: number;
    isVisible: boolean;
    className?: string;
    style?: Record<string, string>;
}

Animated.defaultProps = {
    animationIn: undefined,
    animationInDelay: undefined,
    animationInDuration: undefined,
    className: undefined,
    style: undefined,
};

function Animated(props: PropsWithChildren<AnimatedProps>): ReactElement {
    const {animationIn, animationInDelay, animationInDuration, isVisible, className, style, children} = props;

    const DEFAULT_ANIMATION_DURATION = 1.25;
    const DEFAULT_ANIMATION_DELAY = 0;

    function getStyles(): Record<string, string> {
        return {
            width: 'fit-content',
            ...(style || {}),
            animationDuration: `${animationInDuration || DEFAULT_ANIMATION_DURATION}s`,
            animationDelay: `${animationInDelay || DEFAULT_ANIMATION_DELAY}s`,
        };
    }

    function getClasses(): string {
        return ['animated', className, animationIn].filter((e) => e !== undefined).join(' ');
    }

    if (isVisible) {
        return (
            <div className={getClasses()} style={getStyles()}>
                {children}
            </div>
        );
    }

    return <div />;
}

export default Animated;
